var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.botid)?_c('BotFlow',{attrs:{"botid":_vm.botid,"config":{review: true},"data-testid":"financialclose-automation-riskmanagement-bot-view"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }